import { useState, useEffect } from 'react';
import { useParams } from '@reach/router';
import {
  useAllowByEmailDomain,
  useAllowByPermission,
  useAllowByQuestionEditPermissions,
} from '../../../../../hooks';
import { useAuth } from '@calefy-inc/authentication';
import { InsufficientPermissionsErrorPage } from '../../../../common/ErrorHandling';
import { useLazyQuery } from '@apollo/client';
import { FINAL_FORM } from '../../../../../queries';
import { ProgramBuilderForm } from '../../../../FormManager/classes';
import LoadingScreen from '../../../components/LoadingScreen';
import { ErrorView } from '../../../../common/ErrorView';
import FormBuilder from '../../../../FormManager/FormBuilder';
import { useIsPolicyStreamOrganization } from '../../../../PolicyStream/hooks/useIsPolicyStreamOrganization';

export const EditFormByIdManager = () => {
  const { formId } = useParams();
  const isPolicyStreamOrganization = useIsPolicyStreamOrganization();
  const { token } = useAuth();
  const hasCorrectDomain = useAllowByEmailDomain('calefy.ca');
  const hasFormEditPermissions = useAllowByPermission('edit:forms');
  const { allowed: hasQuestionEditPermissions } =
    useAllowByQuestionEditPermissions();
  const canOpenForm =
    hasCorrectDomain === true ||
    hasFormEditPermissions === true ||
    hasQuestionEditPermissions === true;
  const [form, setForm] = useState<ProgramBuilderForm>();
  const [getForm, { loading, error }] = useLazyQuery(FINAL_FORM, {
    onCompleted: (data) => {
      if (data.finalForm) {
        setForm(ProgramBuilderForm.generateFromBackendResponse(data.finalForm));
      }
    },
  });

  useEffect(() => {
    if (token && canOpenForm && formId) {
      getForm({
        variables: {
          token,
          id: formId,
        },
      });
    }
  }, [token, canOpenForm, formId]);

  if (
    (hasFormEditPermissions === false &&
      hasQuestionEditPermissions === false &&
      hasCorrectDomain !== true) ||
    isPolicyStreamOrganization
  ) {
    return <InsufficientPermissionsErrorPage />;
  }
  if (loading) {
    return <LoadingScreen />;
  }
  if (error) {
    return <ErrorView />;
  }
  if (form) {
    return <FormBuilder form={form} />;
  }
  return null;
};
